import { isProductInStock } from "../../../pages/products/productStockDisplay";

/**
 * Share → visit conversion: compares unique catalogue openers to issued share links.
 * Not a funnel "add to cart" rate — it answers: "Did people we shared with actually open?"
 */
export function computeShareToVisitConversion(
  uniqueVisitors: number,
  sharesIssued: number
): { percent: number | null; label: string } {
  if (sharesIssued <= 0) {
    return {
      percent: null,
      label:
        sharesIssued === 0 && uniqueVisitors > 0
          ? "Share this catalogue to measure link-to-visit conversion."
          : "Issue at least one share link to measure conversion.",
    };
  }
  return {
    percent: Math.min(100, (uniqueVisitors / sharesIssued) * 100),
    label: "Unique visitors ÷ share links issued (capped at 100%).",
  };
}

export function engagementVarietyRate(
  uniqueUsers: number,
  totalViewEvents: number
): number | null {
  if (totalViewEvents <= 0 || uniqueUsers <= 0) return null;
  return Math.min(100, (uniqueUsers / Math.max(totalViewEvents, 1)) * 100);
}

export type QuickProductRow = {
  id: string;
  name: string;
  status: "in_stock" | "low_stock" | "out_of_stock";
  imageUrl?: string;
};

function resolveQuickProductImage(product: any): string | undefined {
  const candidates = [
    product?.thumbnailDetails?.media?.[0]?.mediaURL,
    product?.thumbnailDetails?.media?.[0]?.url,
    product?.thumbnail?.mediaURL,
    product?.thumbnail?.url,
    product?.images?.[0]?.mediaURL,
    product?.images?.[0]?.url,
    product?.images?.[0],
    product?.media?.[0]?.mediaURL,
    product?.media?.[0]?.url,
    product?.image?.mediaURL,
    product?.image?.url,
    product?.imageUrl,
  ];
  const found = candidates.find((value) => typeof value === "string" && value.trim().length > 0);
  return found ? String(found).trim() : undefined;
}

/** Map org catalogue product API doc to Basic Details quick list row */
export function mapCatalogueProductToQuickRow(product: any): QuickProductRow {
  const id = String(product?.productUniqueId || product?._id || product?.id || "").trim();
  const name =
    typeof product?.name === "string"
      ? product.name
      : String(product?.name?.name || product?.name?._id || id || "Product");

  return {
    id: id || String(product?._id || ""),
    name,
    status: isProductInStock(product) ? "in_stock" : "out_of_stock",
    imageUrl: resolveQuickProductImage(product),
  };
}
